module.exports = __webpack_public_path__ + "img/17.95009367.jpg";